import React from "react";
import Testimonials from "../components/common/Testimonials";

const AboutUs = () => {
  const technologies = [
    {
      name: "Motion Sensor",
      desc: "Enabled with motion sensor technology, our cutting-edge chimneys can detect any movement in front of them. This is a unique feature that gives our chimneys a futuristic edge. The motion sensor feature enables the chimneys to be switched on with just the wave of a hand. This makes the chimneys extremely easy-to-use and provides a handy alternative to the chimney's monitoring which even children can control.",
      img: "img/hand_sensor.png",
    },
    {
      name: "Maximum Suction",
      desc: "The chimneys come with powerful suction power. The maximum suction feature makes our chimneys one of the best kitchen chimneys available in India. The maximum suction leads to removal of combustion products, fumes, odour, steam, heat, smoke, and grease that develops during the process of cooking. The flow of air is most important as it prevents your kitchen from turning into a smoke-zone.",
      img: "img/maximum_suction.png",
    },
    {
      name: "Energy Efficient Light",
      desc: "Chimneys from the house of Alpha Appliances are highly energy-efficient. The lamps illuminate a wider surface but consume less power; this makes them handy for viewing your countertops easily. This unique feature makes our chimneys eco-friendly as well as cost-effective.",
      img: "img/energy.jpg",
    },
    {
      name: "Baffle Filter",
      desc: "Made from stainless steel, our chimneys come with baffle filters which effectively push the oil and residue to collect inside the baffle. The grease-saturated air is forced to change directions repeatedly. As the grease droplets are slower than air, hence they get condensed inside the metal blades and end up getting collected in the filter tray.",
      img: "img/buffle_filter.jpg",
    },
    {
      name: "Metal Blower",
      desc: "Metal blowers ensure maximum suction and durability. The metal blowers are connected to a duct system. The metal blower eliminates the task of replacement of filters at regular intervals. Thus they elongate the life term of the chimney. They also help to remove the excess heat in the kitchen area. The metal blowers help the chimneys to exhaust all kinds of air-borne contamination.",
      img: "img/mettle_blower.jpg",
    },
    {
      name: "Timer",
      desc: "Most of us lead a busy life comprising hectic schedules, often with the need to engage in multitasking. This leaves us with very little time for ourselves. On certain occasions, we have of things on our mind and maintenance of kitchen appliances is likely to be among the last on the list.",
      img: "img/digital_timer.jpg",
    },
    {
      name: "Auto Clean",
      desc: "Auto Clean is a state of the art feature that helps in cleaning the oil and residue formed inside the motor with just one touch. Chimneys that are equipped with the auto clean feature are extremely useful because cleaning chimneys can be time-consuming. With the auto clean feature, the residue and oil collected in the chimney get cleaned on its own. This makes your work easier and the appliance low maintenance.",
      img: "img/digital_cleaning.png",
    },
    {
      name: "Powerful Motor",
      desc: "Alpha Appliances presents Chimneys enabled with Powerful motor with high suction capacity, longer operational life, less power consumption, and less noise. What more could one ask for? The high suction capacity ensures that the smoke is sucked out quickly. Being energy-efficient, this chimney is a must-have in your kitchen. The motor is not just power-packed but is also robust in built and is highly durable.",
      img: "img/powerfull_moter.jpg",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-indigo-600 to-indigo-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              <span className="text-orange-400">About</span> Alpha Appliances
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
              Your trusted partner for premium kitchen appliances and innovative
              cooking solutions since 2008.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-6 border border-orange-300">
                <h3 className="text-2xl font-bold mb-2 text-orange-300">
                  15+ Years
                </h3>
                <p className="text-lg">Of industry experience</p>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-6 border border-orange-300">
                <h3 className="text-2xl font-bold mb-2 text-orange-300">
                  Premium Quality
                </h3>
                <p className="text-lg">Cutting-edge technology</p>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-6 border border-orange-300">
                <h3 className="text-2xl font-bold mb-2 text-orange-300">
                  Customer First
                </h3>
                <p className="text-lg">Exceptional service</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Images */}
            <div className="space-y-6">
              <img
                className="w-full rounded-2xl shadow-xl"
                src={"img/about/lyra.webp"}
                alt="Alpha Appliances Showroom"
                loading="lazy"
              />
              <img
                className="w-full rounded-2xl shadow-xl"
                src={"img/about/about.webp"}
                alt="Our Products"
                loading="lazy"
              />
            </div>

            {/* Content */}
            <div className="space-y-6">
              <h2 className="text-3xl md:text-4xl font-bold text-indigo-600">
                Welcome to{" "}
                <span className="text-orange-500">Alpha Appliances</span>
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                Your single window solution for sales, services, AMC, and spare
                parts for all your kitchen appliances. We bring you the world of
                enhanced and delightful cooking with our exclusive range of
                exquisitely crafted kitchen appliances.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                Our products are sleek, stylish, durable, and high on
                performance. <span className="text-orange-500">Alpha's</span>{" "}
                wide range of Hobs & Hoods are inspired by aesthetically
                pleasing <strong>"Indian designs"</strong> and{" "}
                <strong>"Indian craftsmanship"</strong>.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                For a smoke-free and healthy cooking experience, you can bank
                upon the chimneys from{" "}
                <span className="text-orange-500">Alpha Appliances</span>. A
                unique blend of futuristic design and cutting-edge technology,
                these chimneys let you cook minus the fumes while complementing
                your classy kitchen interiors.
              </p>
              <div className="bg-gradient-to-r from-indigo-50 to-orange-50 rounded-xl p-6 border-l-4 border-orange-500">
                <h3 className="text-xl font-bold text-indigo-600 mb-2">
                  Why Choose Alpha Appliances?
                </h3>
                <ul className="text-gray-700 space-y-2">
                  <li>• Premium quality materials and craftsmanship</li>
                  <li>• Advanced technology and innovative features</li>
                  <li>• Comprehensive after-sales support</li>
                  <li>• Energy-efficient and eco-friendly products</li>
                  <li>• 15+ years of industry expertise</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Technologies Section */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-indigo-600 mb-4">
              Advanced Technologies
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Discover the cutting-edge technologies that make our products
              stand out in the market and provide you with the best cooking
              experience.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {technologies.map((tech, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              >
                <div className="flex items-center justify-center w-16 h-16 bg-indigo-100 rounded-full mb-6 mx-auto">
                  {tech.name === "Motion Sensor" && (
                    <svg
                      className="w-8 h-8 text-indigo-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 10V3L4 14h7v7l9-11h-7z"
                      />
                    </svg>
                  )}
                  {tech.name === "Maximum Suction" && (
                    <svg
                      className="w-8 h-8 text-indigo-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                      />
                    </svg>
                  )}
                  {tech.name === "Energy Efficient Light" && (
                    <svg
                      className="w-8 h-8 text-indigo-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                      />
                    </svg>
                  )}
                  {tech.name === "Baffle Filter" && (
                    <svg
                      className="w-8 h-8 text-indigo-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                      />
                    </svg>
                  )}
                  {tech.name === "Metal Blower" && (
                    <svg
                      className="w-8 h-8 text-indigo-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 10V3L4 14h7v7l9-11h-7z"
                      />
                    </svg>
                  )}
                  {tech.name === "Timer" && (
                    <svg
                      className="w-8 h-8 text-indigo-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  )}
                  {tech.name === "Auto Clean" && (
                    <svg
                      className="w-8 h-8 text-indigo-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                      />
                    </svg>
                  )}
                  {tech.name === "Powerful Motor" && (
                    <svg
                      className="w-8 h-8 text-indigo-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 10V3L4 14h7v7l9-11h-7z"
                      />
                    </svg>
                  )}
                </div>
                <h3 className="text-xl font-bold text-indigo-600 mb-4 text-center">
                  {tech.name}
                </h3>
                <p className="text-gray-600 leading-relaxed text-center">
                  {tech.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Testimonials />
    </div>
  );
};

export default AboutUs;
